<template>
    <section :class="['absolute inset-y-0 pl-10 max-w-full flex', centered ? '' : 'right-0']">
        <div class="w-screen max-w-5xl">
            <div class=" flex flex-col h-screen bg-white shadow-xl overflow-hidden">
                <div class="relative flex flex-1 h-full">

                    <autralis-success-comp :show="saved" :text="successMessage"/>
                    <autralis-error-comp :show="error !== null" :text="error"/>

                    <autralis-modal-comp :modal="modal"/>
                    <autralis-info-comp :show="noChangesMessage !== null" :text="noChangesMessage"/>


                    <div class="flex flex-col w-full flex-1">
                        <div class="bg-white pb-6 sticky top-0 z-10">
                            <header id="add-supplier-header" class="space-y-1 py-2 px-6 bg-blue-700 ">
                                <div class="flex items-center justify-between">
                                    <div class="flex space-x-4">
                                        <button @click="save" class="primary-button">
                                        <span v-if="saving" class="flex items-center">
                                            <span class="fas fa-spinner-third fa-spin mr-2"></span> <translate>Saving</translate> ...
                                        </span>
                                            <span v-if="!saving && type === 'add'"><i class="fal fa-plus mt-1 mr-1"></i> Add</span>
                                            <span v-if="!saving && type === 'edit'"><i class="fal fa-save mt-1 mr-1"></i> Save</span>
                                        </button>
                                    </div>


                                    <div class="flex">
                                        <div v-if="type === 'edit'" class="border-r border-gray-100 border-opacity-30 pr-6 mr-6 relative">
                                            <i class="fal fa-ellipsis-h-alt text-white text-lg text-white hover:text-gray-300 transition ease-in-out duration-150 cursor-pointer"
                                               @click="menuOpen = !menuOpen;"
                                            />
                                            <div v-if="menuOpen" class="bg-white absolute right-0 rounded-md shadow-lg p-4 dropdown-nav" style="">
                                                <!-- DELETE BUTTON -->
                                                <button @click="confirmDelete" class="text-red-500 hover:text-red-700 transition-all ease-in duration-100 font-medium sm:text-sm">
                                                    <span v-if="deleting" class="flex items-center">
                                                        <span class="fas fa-spinner-third fa-spin mr-2"></span> <translate>Deleting</translate> ...
                                                    </span>
                                                    <span v-else><i class="fal fa-trash mt-1 mr-1"/> Delete</span>
                                                </button>


                                            </div>
                                        </div>


                                        <div class="flex">
                                            <div class="hidden h-6 md:flex items-center mr-4">
                                                <i class="fas fa-arrows-alt-h text-white hover:text-gray-300 transition ease-in-out duration-150 cursor-pointer mt-1"
                                                   @click="centered = !centered"/>
                                            </div>
                                            <div class="h-6 flex items-center">
                                                <i class="fal fa-times text-white text-2xl hover:text-gray-300 transition ease-in-out duration-150 cursor-pointer mt-1" @click="close"/>
                                            </div>

                                        </div>
                                    </div>


                                </div>
                            </header>
                        </div>

                        <div v-if="saving" class="absolute inset-x-0 bottom-0 bg-black bg-opacity-30 z-20" :style="{top: headerHeight + 'px'}"/>

                        <div class="px-6">
                            <div v-if="type==='edit' && !fetching">
                                <autralis-supplier-status :supplier-id="supplier.id"
                                                          :classNameConfig="{
                                                                'wrapper': 'flex',
                                                                'nextButton': 'ml-4'
                                                          }"/>
                            </div>
                            <div class="flex items-center w-full border-b border-gray-200 mb-6 pb-6">
                                <div class="pr-4 text-blue-700 text-3xl">
                                    <i class="fal fa-building"></i>
                                </div>
                                <div class="pl-2">
                                    <div class="text-gray-600 text-2xl font-bold">Supplier</div>
                                    <div v-if="type === 'edit'" class="text-gray-600 text-sm">Edit or update the supplier info by changing the info below.</div>
                                    <div v-if="type === 'add'" class="text-gray-600 text-sm">Fill the info below and click on save to add new supplier.</div>
                                </div>
                            </div>
                        </div>

                        <autralis-loading-comp v-if="fetching"/>

                        <div v-else class="flex flex-col flex-1 md:flex-row w-full px-6 overflow-y-scroll pb-6">
                            <div class="w-full">
                                <div class="flex flex-col items-center">
                                    <div class="flex flex-col md:flex-row w-full space-x-0 md:space-x-4 mb-6">
                                        <div class="w-full md:w-2/3">
                                            <autralis-input-group-comp label="Company name"
                                                                       :error="formErrors.name"
                                                                       :value="supplier.name"
                                                                       required
                                                                       placeholder="Autralis Dealership"
                                                                       @on-change="handleChange('name', $event)"/>

                                        </div>
                                        <div class="w-full md:w-1/3 mt-4 md:mt-0 z-10">
                                            <autralis-countries-select-comp label='Country'
                                                                            :selected="supplier.countryCode"
                                                                            :error="formErrors.countryCode"
                                                                            required
                                                                            @on-country-change="handleChange('countryCode', $event)"/>
                                        </div>
                                    </div>
                                    <div class="flex flex-col md:flex-row w-full space-x-0 md:space-x-4 mb-6">
                                        <div class="w-full md:w-1/3">
                                            <autralis-input-group-comp label="Reference"
                                                                       :value="supplier.reference"
                                                                       placeholder=""
                                                                       @on-change="handleChange('reference', $event)"/>

                                        </div>
                                        <div class="w-full md:w-1/3 my-4 md:my-0">
                                            <autralis-input-group-comp label="Vat number"
                                                                       :error="formErrors.vatNumber"
                                                                       :value="supplier.vatNumber"
                                                                       required
                                                                       placeholder=""
                                                                       @on-change="handleChange('vatNumber', $event)"/>
                                        </div>
                                        <div class="w-full md:w-1/3">
                                            <autralis-input-group-comp label="Company key"
                                                                       :disabled="true"
                                                                       :value="supplier.companyKey"
                                                                       :placeholder="type === 'edit' ? 'sEWqcUsWH0ivNQQQ' : 'auto-generated'"
                                            />
                                        </div>
                                    </div>
                                    <div class="flex flex-col md:flex-row w-full space-x-0 md:space-x-4 mb-6">
                                        <div class="w-full md:w-1/3">
                                            <autralis-input-group-comp label="Email"
                                                                       :error="formErrors.email"
                                                                       :value="supplier.email"
                                                                       required
                                                                       placeholder="info@company.com"
                                                                       @on-change="handleChange('email', $event)"/>

                                        </div>
                                        <div class="w-full md:w-1/3 my-4 md:my-0">
                                            <autralis-input-group-comp label="Telephone"
                                                                       :error="formErrors.telephone"
                                                                       :value="supplier.telephone"
                                                                       placeholder="+32 9 210 10 10"
                                                                       @on-change="handleChange('telephone', $event)"/>
                                        </div>
                                        <div class="w-full md:w-1/3">
                                            <autralis-input-group-comp label="Mobile"
                                                                       :error="formErrors.mobile"
                                                                       :value="supplier.mobile"
                                                                       placeholder="+32 486 38 48 58"
                                                                       @on-change="handleChange('mobile', $event)"/>
                                        </div>
                                    </div>

                                    <div class="flex flex-col w-full mb-6" v-if="!fetchingManagers">
                                        <autralis-select-multiple-comp :options="managers"
                                                                       :selectedOptions="supplier.managers"
                                                                       @on-change="handleChange('managers', $event)"
                                                                       placeholder="Select managers"
                                                                       label="Managers"/>

                                    </div>

                                    <!--                                    <div class="flex flex-col w-full" v-if="!fetchingProfiles">-->
                                    <!--                                        <autralis-select-multiple-comp :options="profiles"-->
                                    <!--                                                                       :selectedOptions="supplier.profiles"-->
                                    <!--                                                                       @on-change="handleChange('profiles', $event)"-->
                                    <!--                                                                       placeholder="Select profiles"-->
                                    <!--                                                                       label="Profiles"/>-->
                                    <!--                                    </div>-->

                                    <div class="flex flex-col w-full">
                                        <selector-checkboxes :options="profiles"
                                                             label="Select profiles"
                                                             :selected-options="supplier.profiles"
                                                             :loading="fetchingProfiles"
                                                             :styles="{'wrapper': 'w-full md:w-2/3'}"
                                                             @on-change="handleChange('profiles', $event)"
                                        />
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>


                </div>
            </div>
        </div>
    </section>
</template>

<script>
import SuccessBox from "@/components/success-box";
import InfoBox from "@/components/info-box";
import ErrorBox from "@/components/error-box";
import Modal from "@/components/modal";
import Loading from "@/components/loading";
import InputGroup from "@/components/input-group";
import SelectMultiple from "@/components/select-multiple";
import {modalInfo} from "@/common/modal";
import CountriesSelect from "@/components/countries-select";
import {handleChangeSupplierStatus, handleFetchSupplier, handleSaveSupplier} from "../handlers";
import {STATE_TRIGGERS, STATES} from "../../states-and-triggers";
import {isEqual, map, orderBy} from "lodash";
import SupplierStatus from "@/master/views/Home/suppliers/components/SupplierStatus";
import {INFO_BOX_TIMEOUT} from "@/master/constants";
import {isValidEmail, isValidEUVAT} from "@/common";
import {handleFetchCompanyManagers, handleFetchCompanyProfiles} from "@/master/views/Home/company/handlers";
import Selector from "@/components/selector-checkboxes";
import {getElementDimensionsById} from "@/master/utils";

const INIT_SUPPLIER = {
    name: '',
    countryId: '',
    countryCode: '',
    reference: '',
    vatNumber: '',
    companyKey: '',
    mobile: '',
    telephone: '',
    email: '',
    profiles: [],
    managers: []
}

export default {
    name: "AddSupplier",
    data() {
        return {
            supplier: INIT_SUPPLIER,
            initSupplier: INIT_SUPPLIER,
            formErrors: {},
            managers: [],
            profiles: [],
            saved: null,
            successMessage: '',
            error: null,
            noChangesMessage: null,
            modal: modalInfo(),
            type: 'edit',
            saving: false,
            fetching: false,
            centered: false,
            fetchingManagers: false,
            fetchingProfiles: false,
            menuOpen: false,
            deleting: false,
            headerHeight: 0
        }
    },

    computed: {
        supplierStatus() {
            return STATES[this.supplier.state] ? STATES[this.supplier.state] : null;
        },

        saveAllowed() {
            return !isEqual(this.supplier, this.initSupplier)
        }
    },

    methods: {
        setSupplier() {
            const id = this.$store.getters['master/detail'].id;

            if (id) {
                this.fetchSupplier(id);
            } else {
                this.type = 'add'
            }
        },

        async handleDelete() {
            try {
                this.deleting = true;
                this.error = null

                const payload = {
                    supplierID: this.$store.getters['master/detail'].id,
                    trigger: STATE_TRIGGERS.LOCK,

                };

                // eslint-disable-next-line no-unused-vars
                await handleChangeSupplierStatus(payload, (updatedSuppliers) => {
                    this.$store.commit('master/setSuppliers', updatedSuppliers)
                }, (error) => {
                    this.error = error
                })

                this.deleting = false;
                this.menuOpen = false

            } catch (err) {
                console.log(err)
                this.error = 'The supplier could not be locked. Please try again.'
                this.deleting = false;
            }
        },

        confirmDelete() {
            const msg = "You can not delete supplier. You can only LOCK him. Do you want to do that?";
            this.modal.view('Lock the supplier', msg, 'Confirm', 'exclamation-triangle', this.handleDelete)
        },


        async fetchSupplier(supplier_id) {

            const payload = {
                supplier_id: supplier_id,
                companyId: this.$store.getters['master/company'].id
            }

            this.fetching = true;
            this.error = null;

            await handleFetchSupplier(payload, (response) => {
                const {supplier} = response;
                const formattedSupplier = {
                    ...supplier,
                    managers: map(supplier.managers, manager => ({value: manager.id, text: manager.firstName + ' ' + manager.lastName})),
                    profiles: map(supplier.profiles, profile => profile.id)
                }

                this.supplier = {...formattedSupplier};
                this.initSupplier = {...formattedSupplier};

            }, (error) => {
                this.error = error
            })

            this.fetching = false;
        },

        async fetchManagers() {
            this.fetchingManagers = true;

            const payload = {
                companyId: this.$store.getters['master/company'].id
            }

            await handleFetchCompanyManagers(payload, (response) => {
                const {managers} = response;
                this.managers = map(managers, manager => ({value: manager.id, text: manager.firstName + ' ' + manager.lastName}))
            }, (error) => {
                console.log(error)
                // this.error = error
            })

            this.fetchingManagers = false;
        },

        async fetchProfiles() {
            this.fetchingProfiles = true;
            /*this.error = null;*/

            await handleFetchCompanyProfiles((response) => {
                const {profiles} = response;
                this.profiles = map(profiles, profile => ({id: profile.id, name: profile.name}));

            }, (error) => {
                console.log(error)
                // this.error = error
            })

            this.fetchingProfiles = false;
        },

        handleChange(field, value) {
            this.supplier = {...this.supplier, [field]: value}
        },

        close() {
            this.$store.commit('master/setDetail', null);
            this.$store.commit('master/closeDetail');
        },

        async save() {
            if (this.isValid()) {
                if (this.saveAllowed) {
                    const payload = {
                        supplier: {
                            ...this.supplier,
                            managers: map(this.supplier.managers, manager => manager.value),
                        }
                    }

                    this.saving = true;
                    this.error = null;

                    await handleSaveSupplier(payload, (response) => {
                        this.$store.commit('master/setSuppliers', orderBy(response.updatedSuppliers, ['name'], ['asc']))
                        // this.setStoreUsers(response.users)
                        if (this.type !== 'edit') {
                            this.supplier = INIT_SUPPLIER;
                            this.initSupplier = INIT_SUPPLIER;
                            setTimeout(() => this.close(), INFO_BOX_TIMEOUT)
                        }
                        this.successMessage = 'The changes saved successfully.'
                        this.saved = true;
                    }, (error) => {
                        this.error = error
                    })

                    this.saving = false;
                } else {
                    this.noChangesMessage = 'Nothing changed.';
                    setTimeout(() => this.noChangesMessage = null, INFO_BOX_TIMEOUT)
                }
            }
        },

        validateForm() {
            let isValid = true;
            let errors = {};

            if (!this.supplier.name) {
                errors['name'] = "The name cannot be empty.";
                isValid = false;
            }

            if (!this.supplier.countryCode) {
                errors['countryCode'] = "The country cannot be empty.";
                isValid = false
            }

            if (!isValidEUVAT(this.supplier.vatNumber)) {
                errors['vatNumber'] = "The VAT number cannot be empty.";
                isValid = false
            }

            if (!isValidEmail(this.supplier.email)) {
                errors['email'] = "The email address needs to be valid.";
                isValid = false
            }

            return {
                isValid,
                errors
            }
        },

        isValid() {
            this.formErrors = {};
            const {isValid, errors} = this.validateForm();
            this.formErrors = {...errors}
            return isValid
        }
    },

    created() {
        this.fetchManagers();
        this.fetchProfiles();
        this.setSupplier();
    },

    mounted() {
        const header = getElementDimensionsById("add-supplier-header")
        if (header) {
            this.headerHeight = header.height
        }
    },

    components: {
        'autralis-success-comp': SuccessBox,
        'autralis-info-comp': InfoBox,
        'autralis-error-comp': ErrorBox,
        'autralis-modal-comp': Modal,
        'autralis-input-group-comp': InputGroup,
        'autralis-loading-comp': Loading,
        'autralis-select-multiple-comp': SelectMultiple,
        'autralis-countries-select-comp': CountriesSelect,
        'autralis-supplier-status': SupplierStatus,
        'selector-checkboxes': Selector
    }
}
</script>

<style scoped>
.dropdown-nav {
    top: 100%;
    min-width: 150px;
    width: -webkit-max-content;
    width: -moz-max-content;
    width: max-content;
}

</style>